import axios from 'axios'

const state = () => ({
  addPage: []
})

const getters = {
  addPage(state) {
    return state.addPage
  }
}

const mutations = {
  SET_ADDPAGE(state, payload){
    state.addPage = payload
  },
  DELETE_PAGE(state, id){
    state.addPage = state.addPage.filter((x) => x.id != id);
  },
  ADD_PAGE(state, data){
    state.addPage.push(data);
  },
  EDIT_PAGE(state, data){
    state.addPage = state.addPage.map((vm)=>{
      if(vm.id == data.id){ return data}
      else{ return vm }
    });
  }
}

const actions = {
  getPages({commit}){
    axios.get('https://api.geomalaka.uz/api/employee/admin_the_page/')
    .then((res)=>{
      commit("SET_ADDPAGE", res.data)
      // this._vm.$toast('Successful', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  deletePage({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/employee/admin_the_page/${id}/`)
    .then((res)=>{
      commit("DELETE_PAGE", id)
      this._vm.$toast('Deleted', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  addPages({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/employee/admin_the_page/', payload)
    .then((res)=>{
      commit("ADD_PAGE", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  editPage({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/employee/admin_the_page/${payload.id}/`, payload.data)
    .then((res)=>{
      commit("EDIT_PAGE", res.data)
      this._vm.$toast('Successful', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

